import styled from 'styled-components';
import { config } from '../../components/dashboards/config';

export default styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  .sca-graph-tooltip {
    min-width: 180px;
    padding: 12px 0px;
    display: flex;
    flex-direction: column;

    .tooltip-header {
      padding-bottom: 8px;
      margin-bottom: var(--size);
      border-bottom: 1px solid #EAECF0;

      h3 {
        font-size: 14px;
        font-weight: 700;
        color: #1D2939;
        margin-bottom: 5px;
      }

      h4 {
        font-size: 12px;
        font-weight: 500;
        color: #667085;
        margin-bottom: 0px;
      }

      h5 {
        font-size: 12px;
        margin-bottom: 0px;
        font-weight: 300;
      }
    }

    .items {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .item { 
        display: flex;
        gap: 6px;

        .cont {
          display: flex;

          flex-direction: column;
          justify-content: center;

          label {
            margin-bottom: 0px;
            font-weight: 500;
          }

          .legend {
            width: 9px;
            height: 9px;
            border-radius: 100%;
          }

          &.label {
            flex: 1;

            label {
              font-size: 12px;
              color: #667085;
              font-weight: 500;
            }
          }

          &.value {
            label {
              font-size: 12px;
              color: #1D2939;
              font-weight: 700;
            }
          }
        }
      }
    }
  }

  .content {
    width: 100%;
    flex: 1;
    overflow: auto;
    display: flex;

    .view-content {
      flex: 1;
      overflow-y: auto;
      scroll-behavior: smooth;
      background: ${config.DASHBOARD_BACKGROUND};
    }
  }
  
  .sider-header {
    padding: 9px 11px;
    display: flex;
    border-bottom: 1px solid #CCCCCC;

    label {
      flex: 1;
      font-size: 14px;
      font-weight: 500;
    }

    svg {
      margin-top: 4px;
      cursor: pointer;
      fill: #BCBCBC;
    }
  }

  .per-time-tooltip {
    min-width: 180px;
    padding: 12px 0px;
    display: flex;
    flex-direction: column;

    .label {
      font-size: 14px;
      font-weight: 700;
      color: #001529;
    }

    .second-label {
      font-size: 12px;
      font-weight: 500;
      color: #667085;
      padding-bottom: 8px;
      border-bottom 1px solid #EAECF0; 
    }

    .value {
      display: flex;
      justify-content: space-between;

      label {
        margin-bottom: 0px;
        font-size: 12px;
        color: #475467;
      }

      .title {
        font-weight: 500;
        flex: 1;
      }

      .percentage {
        color: #1D2939;
        font-weight: 700;
      }
    }
  }

  .default-progress-cont {
    display: flex;
    flex: 1;

    label {
      width: 60px !important;
      text-align: right;
      margin-right: 10px;
      font-weight: 500;
      margin-bottom: 0px;

      &.is-active {
        color: black;
      }

      &.green{
        color: #52C41A !important;
      }

      &.no-margin-right {
        margin-right: 0px !important;
      }
    }

    .progress {
      flex: 1;
      height: 10px;
      height: 10px;
      margin-top: 9px;
      
      div {
        border-radius: 12px;
      }
    }
  }
`;

export const GraphWithLegend = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  .legend-cont {
    flex 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
